import { Component } from 'react'

const canUseDOM = () => typeof window !== 'undefined' && window.document && window.document.createElement

export const ZendeskAPI = (...args) => {
  if (canUseDOM() && window.zE) {
    window.zE.apply(null, args)
  }
}

export default class ZendeskChat extends Component {
  constructor(props) {
    super(props)
    this.insertScript = this.insertScript.bind(this)
    this.onScriptLoaded = this.onScriptLoaded.bind(this)
  }

  onScriptLoaded() {
    if (window.zE) {
      window.zE('messenger:set', 'locale', 'en')
      window.zE('messenger', 'show')
    }

    if (typeof this.props.onLoaded === 'function') {
      this.props.onLoaded()
    }
  }

  insertScript(zendeskKey, defer) {
    const script = document.createElement('script')
    if (defer) {
      script.defer = true
    } else {
      script.async = true
    }
    script.id = 'ze-snippet'
    script.src = `https://static.zdassets.com/ekr/snippet.js?key=${zendeskKey}`
    script.addEventListener('load', this.onScriptLoaded)
    document.body.appendChild(script)
  }

  componentDidMount() {
    const { defer, zendeskKey, locale, ...zeSettings } = this.props
    const scriptAlreadyLoaded = !!document.getElementById('ze-snippet')

    if (canUseDOM() && !scriptAlreadyLoaded) {
      this.insertScript(zendeskKey, defer)
      window.zESettings = {
        ...zeSettings,
        webWidget: {
          ...(zeSettings.webWidget || {}),
          locale: 'en', // Force English locale
        },
      }
    } else if (window.zE) {
      window.zE('messenger:set', 'locale', 'en')
      if (typeof this.props.onLoaded === 'function') {
        this.props.onLoaded()
      } else {
        window.zE('messenger', 'show')
      }
    }
  }

  componentWillUnmount() {
    if (!canUseDOM() || !window.zE) return

    try {
      window.zE('messenger', 'hide')
    } catch (e) {
      console.warn('Error while cleaning up Zendesk:', e)
    }
  }

  render() {
    return null
  }
}
